import { Component, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import {
  PermissionCheckerService,
  PershingTranslationService,
} from '@pershing/pershing-core';
import { AboutUsComponent } from './about-us.component';

@Component({
  template: '',
})
export class ContactUsBaseComponent {
  isActive: boolean = false;
  entitledForAdvisorInfo: boolean;
  entitledForAboutUs: boolean;
  constructor(
    protected dialog: MatDialog,
    protected authorizationService: PermissionCheckerService,
    protected translationService: PershingTranslationService
  ) {
    this.translationService.addTranslationFolder(
      '@pershing/nxi-ng-modern-navigation',
      'node_modules/@pershing/nxi-ng-modern-navigation/lib'
    );
    this.entitledForAdvisorInfo =
      this.authorizationService.isEntitled('FINANCIAL_ADVISOR');
    this.entitledForAboutUs = this.authorizationService.isEntitled(
      'CONTACT_BROKERAGE || ABOUT_US || FINANCIAL_ADVISOR || OUTSIDE_LINKS || DOWNLOAD_FORMS'
    );
  }

  contactUs() {
    this.dialog.open(AboutUsComponent, {
      width: '800px',
      panelClass: ['modal', 'fw-Advisor_AboutUs'],
    });
  }
}
